'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _nodeFetch = require('node-fetch');

var _nodeFetch2 = _interopRequireDefault(_nodeFetch);

var _httpRequestError = require('../errors/http-request-error');

var _httpRequestError2 = _interopRequireDefault(_httpRequestError);

var _requestMethod = require('./request-method');

var _requestMethod2 = _interopRequireDefault(_requestMethod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getOptions() {
    var options = {};
    options.method = this.method || _requestMethod2.default.GET;
    options.body = this.body || null;
    options.headers = this.headers || {};
    return options;
}
/**
 * Creates an HTTP Request with set headers, method and body.
 */

var HttpRequest = function () {
    /**
     * @param {String} url - Url to make HTTP Request on.
     * @throws {HttpRequestError} if url is not of type string.
     */
    function HttpRequest(url) {
        _classCallCheck(this, HttpRequest);

        if (typeof url !== 'string') {
            throw new _httpRequestError2.default('Cannot instantiate an HttpRequest object without a url');
        }
        this.url = url;
    }

    /**
     * Set headers for the HTTP Request.
     * @param {*} headers - Headers to be included with Request.
     */


    _createClass(HttpRequest, [{
        key: 'setHeaders',
        value: function setHeaders(headers) {
            this.headers = headers;
        }

        /**
         * Set method for the HTTP Request.
         * @param {*} method - Method of the HTTP Request.
         * @throws {HttpRequestError} if method is not of type ${RequestMethod}.
         */

    }, {
        key: 'setMethod',
        value: function setMethod(method) {
            if (!_requestMethod2.default.values().includes(method)) {
                throw new _httpRequestError2.default('Cannot set method for HttpRequest of type that isn\'t RequestMethod');
            }
            this.method = method;
        }

        /**
         * Sets JSON stringified body on the HTTP Request.
         * @param {*} body - body to be included with Request.
         */

    }, {
        key: 'setBody',
        value: function setBody(body) {
            this.body = JSON.stringify(body);
        }

        /**
         * Makes an HTTP Request with the provided Method, Body and headers.
         * @returns {Promise} result of HTTP fetch request.
         */

    }, {
        key: 'request',
        value: function request() {
            var options = getOptions.bind(this)();
            return (0, _nodeFetch2.default)(this.url, options).then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                return response;
            }).catch(function (err) {
                throw new _httpRequestError2.default(err);
            });
        }
    }]);

    return HttpRequest;
}();

exports.default = HttpRequest;